module.exports = __webpack_public_path__ + "static/anjoupears-04e13a9ce0c308295a4a5ee261f86208.jpg";